/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Dev Inspector",
  "description": "Adds a right-click option to inspect blocks and view their JSON representation with useful debugging information.",
  "credits": [
    {
        "name": "Mistium",
        "url": "https://mistium.com"
    }
  ],
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [
    "developer",
    "MistWarp"
  ],
  "enabledByDefault": true
};
export default manifest;
